import { ScalingPolicyTypeRegistry } from '../ScalingPolicyTypeRegistry';

ScalingPolicyTypeRegistry.registerPolicyType({
  type: 'TargetTrackingScaling',
  summaryTemplateUrl: require('./targetTrackingSummary.html')
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/amazon/src/serverGroup/details/scalingPolicy/targetTracking/TargetTrackingPolicy.config.ts